import * as React from 'react';
import { Layout, Row } from 'antd';
import styled from 'styled-components';

const { Header, Content, Footer } = Layout;

export const CaribTixButton = styled.div`
    
    .MyEventButton {
        text-align: center;

        span {
            background-color: #25c5e6;
            color: white;
            padding: 10px;
        }
    }
` ;















